import axios from "axios";
import { urlAPI_Current } from "./config";

async function verifyUserPaid() {
    try {
        const userPaid = await axios.post(`${urlAPI_Current}/verifyUserPaid`, {}, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
            }
        });

        return {
            success: userPaid.data.success,
            plan: userPaid.data.plan,
            message: userPaid.data.message,
            paymentDate: userPaid.data.paymentDate,
            type: userPaid.data.type
        };
    } catch (err) {
        console.log(err);
    }
}

export { verifyUserPaid };
